import type { Posting } from "@/lib/api/catalogue";
import { actionProps } from "@/lib/controlAnalytics";
import { resumeCheckPath } from "@/lib/routes";

/**
 * The way from a posting's page to its free check. A plain `<a href>`, never a router
 * link: Google follows it in the server's HTML, and a tool's address loads as a new
 * page, so no ad tag is left running (lib/ads).
 */
export default function CheckLink({ posting }: { posting: Posting }) {
    const path = resumeCheckPath(posting.posting_id);
    return (
        <p className="m-0 text-ui [text-wrap:pretty]">
            <a
                {...actionProps("navigation_clicked", {
                    source: "PostingDetail",
                    posting_id: posting.posting_id,
                    target: path,
                })}
                href={path}
                className="font-semibold text-brand-ink"
            >
                {`Check your resume for this job's ${posting.keywords.length} skills, free. Then have AI tailor it.`}
            </a>
        </p>
    );
}
